"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BBOmnibarUserActivity = void 0;
var auth_domain_1 = require("../auth/auth-domain");
var csrf_xhr_1 = require("../shared/csrf-xhr");
var navigator_1 = require("../shared/navigator");
var omnibar_user_activity_processor_1 = require("./omnibar-user-activity-processor");
var omnibar_user_session_expiration_1 = require("./omnibar-user-session-expiration");
var omnibar_user_session_watcher_1 = require("./omnibar-user-session-watcher");
var isTracking;
var clientX;
var clientY;
var currentHideInactivityCallback;
var currentRefreshUserCallback;
var currentShowInactivityCallback;
var isShowingInactivityPrompt;
var lastActivity;
var lastRenewal;
var intervalId;
var lastRefreshId = '';
var currentAllowAnonymous;
var currentLegacyKeepAliveUrl;
var legacyTtl;
var legacySigninUrl;
function trackUserActivity() {
    lastActivity = Date.now();
}
function trackMouseMove(e) {
    // We have seen issues where the browser sometimes raises the mousemove event even when it isn't moving.
    // Since that might prevent the user from ever timing out, adding this check to ensure the location
    // actually changed.
    if (e.clientX !== clientX || e.clientY !== clientY) {
        clientX = e.clientX;
        clientY = e.clientY;
        trackUserActivity();
    }
}
function renewSession() {
    var now = Date.now();
    if (!lastRenewal ||
        now - lastRenewal > BBOmnibarUserActivity.MIN_RENEWAL_RETRY) {
        lastRenewal = now;
        csrf_xhr_1.BBCsrfXhr.request(auth_domain_1.BBAuthDomain.getSTSDomain() + '/session/renew', {
            inactivity: 1,
        }).catch(/* istanbul ignore next */ function () { return undefined; });
    }
}
function addActivityListeners() {
    document.addEventListener('keypress', trackUserActivity);
    document.addEventListener('mousemove', trackMouseMove);
}
function showInactivityPrompt() {
    isShowingInactivityPrompt = true;
    currentShowInactivityCallback();
}
function closeInactivityPrompt() {
    isShowingInactivityPrompt = false;
    trackUserActivity();
    currentHideInactivityCallback();
}
function redirectForInactivity() {
    if (legacySigninUrl) {
        navigator_1.BBAuthNavigator.navigate(legacySigninUrl);
    }
    else {
        navigator_1.BBAuthNavigator.redirectToSignoutForInactivity();
    }
}
function startActivityTimer() {
    var _this = this;
    // It's possible the user was active on another web page and just navigated to this
    // one.  Since the activity tracking does not carry over from the previous page,
    // play it safe and renew the session immediately.
    if (!currentAllowAnonymous) {
        renewSession();
    }
    intervalId = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
        var expirationDate;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, omnibar_user_session_expiration_1.BBOmnibarUserSessionExpiration.getSessionExpiration(lastRefreshId, legacyTtl, currentAllowAnonymous)];
                case 1:
                    expirationDate = _a.sent();
                    // Verify activity tracking didn't stop since session expiration retrieval began.
                    if (isTracking) {
                        omnibar_user_activity_processor_1.BBOmnibarUserActivityProcessor.process({
                            allowAnonymous: currentAllowAnonymous,
                            closeInactivityPrompt: closeInactivityPrompt,
                            expirationDate: expirationDate,
                            inactivityPromptDuration: BBOmnibarUserActivity.INACTIVITY_PROMPT_DURATION,
                            isShowingInactivityPrompt: isShowingInactivityPrompt,
                            lastActivity: lastActivity,
                            maxSessionAge: BBOmnibarUserActivity.MAX_SESSION_AGE,
                            minRenewalAge: BBOmnibarUserActivity.MIN_RENEWAL_AGE,
                            redirectForInactivity: redirectForInactivity,
                            renewSession: renewSession,
                            showInactivityPrompt: showInactivityPrompt,
                        });
                    }
                    return [2 /*return*/];
            }
        });
    }); }, BBOmnibarUserActivity.ACTIVITY_TIMER_INTERVAL);
}
var BBOmnibarUserActivity = /** @class */ (function () {
    function BBOmnibarUserActivity() {
    }
    BBOmnibarUserActivity.startTracking = function (refreshUserCallback, showInactivityCallback, hideInactivityCallback, allowAnonymous, legacyKeepAliveUrl) {
        if (!isTracking ||
            allowAnonymous !== currentAllowAnonymous ||
            legacyKeepAliveUrl !== currentLegacyKeepAliveUrl) {
            BBOmnibarUserActivity.stopTracking();
            currentRefreshUserCallback = refreshUserCallback;
            currentShowInactivityCallback = showInactivityCallback;
            currentHideInactivityCallback = hideInactivityCallback;
            currentAllowAnonymous = allowAnonymous;
            currentLegacyKeepAliveUrl = legacyKeepAliveUrl;
            addActivityListeners();
            startActivityTimer();
            omnibar_user_session_watcher_1.BBOmnibarUserSessionWatcher.start(allowAnonymous, legacyKeepAliveUrl, currentRefreshUserCallback, function (state) {
                legacyTtl = state.legacyTtl;
                lastRefreshId = state.refreshId;
                legacySigninUrl = state.legacySigninUrl;
            });
            isTracking = true;
        }
    };
    BBOmnibarUserActivity.userRenewedSession = function () {
        closeInactivityPrompt();
        renewSession();
    };
    BBOmnibarUserActivity.stopTracking = function () {
        omnibar_user_session_watcher_1.BBOmnibarUserSessionWatcher.stop();
        omnibar_user_session_expiration_1.BBOmnibarUserSessionExpiration.reset();
        document.removeEventListener('keypress', trackUserActivity);
        document.removeEventListener('mousemove', trackMouseMove);
        /* istanbul ignore else */
        if (intervalId) {
            clearInterval(intervalId);
            intervalId = undefined;
        }
        isTracking =
            clientX =
                clientY =
                    lastActivity =
                        lastRenewal =
                            isShowingInactivityPrompt =
                                currentRefreshUserCallback =
                                    currentShowInactivityCallback =
                                        currentHideInactivityCallback =
                                            currentAllowAnonymous =
                                                currentLegacyKeepAliveUrl =
                                                    undefined;
    };
    // The interval in milliseconds that the last activity is evaluated against the session timeout period.
    BBOmnibarUserActivity.ACTIVITY_TIMER_INTERVAL = 1000;
    // The minimum time in milliseconds that must elapse before this omnibar instance will issue a session renewal
    // after the previous session renewal.
    BBOmnibarUserActivity.MIN_RENEWAL_RETRY = 1 * 60 * 1000;
    // The time in millseconds that the expiration prompt will show before the session actually expires.
    BBOmnibarUserActivity.INACTIVITY_PROMPT_DURATION = 2 * 60 * 1000;
    // The minimum age in milliseconds of the session before it will be renewed in response to user activity.
    BBOmnibarUserActivity.MIN_RENEWAL_AGE = 5 * 60 * 1000;
    // The time in millseconds that a session is allowed without activity.  While the actual length of the current
    // session is determined by calls to auth's TTL endpoint, this value is used to determine when to start renewing
    // the session by calculating the difference between the max session age and the min renewal age.
    BBOmnibarUserActivity.MAX_SESSION_AGE = 90 * 60 * 1000;
    return BBOmnibarUserActivity;
}());
exports.BBOmnibarUserActivity = BBOmnibarUserActivity;
